module.exports = __webpack_public_path__ + "923be44ccb2b268ee5960ab3478f5604.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-27.png
// module id = 2468
// module chunks = 0